import { AnyAction } from "redux";
import { SET_USER_REPORTS_LOADED } from "../actions/loadingUserReports";

export const loadingUserReports = (state = false, action: AnyAction) => {
  switch (action.type) {
    case SET_USER_REPORTS_LOADED:
      return action.userReportsLoaded;
    default:
      return state;
  }
};

export default loadingUserReports;
